import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * アカウント削除用クラス
 */
@JsonObject('DeleteParam')
export default class DeleteParam {
  constructor() {
    this.password = undefined;
  }

  @JsonProperty('password')
  public password?: string;
}
